var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye",
    width: "54px",
    height: "32px",
    viewBox: "0 0 54 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-2",
    transform: "translate(-5.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-3",
    transform: "translate(5.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-4",
    fill: "#151515",
    d: "M27,32 C36.9411255,32 45.9411255,26.6666667 54,16 C45.9411255,5.33333333 36.9411255,0 27,0 C17.0588745,0 8.0588745,5.33333333 0,16 C8.0588745,26.6666667 17.0588745,32 27,32 Z",
    className: "icon-inside"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eye-5",
    fill: "#FFFFFF",
    cx: 27,
    cy: 16,
    r: 11,
    className: "icon-inside-inverted"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "eye-6",
    fill: "#151515",
    cx: 27,
    cy: 16,
    r: 7,
    className: "icon-inside"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.8343643550ecc30fabf7ff98a3eb089b.svg";
export { ForwardRef as ReactComponent };